import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const DEFAULT_LOGO = "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/leidenfrost.svg?alt=media&token=aa8b35e7-10dc-4f45-9530-63fef6768eca";

const LeidenfrostLogo = ({ 
  src = DEFAULT_LOGO, 
  alt = "Official Logo", 
  width = 128, 
  height = 64, 
  sx = {}, 
  ...props 
}) => {
  return (
    // Link envuelve al Box y lo dirige a la raíz ("/")
    <Link to="/" style={{ textDecoration: 'none', display: 'inline-block' }}>
      <Box
        component="img"
        src={src}
        alt={alt}
        {...props} 
        sx={{
          height: height,
          width: width,
          objectFit: 'contain', 
          display: 'block',     
          cursor: 'pointer', // Cambia el cursor para indicar que es un enlace
          ...sx                 
        }}
      />
    </Link>
  );
};

LeidenfrostLogo.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.object,
};

export default LeidenfrostLogo;